import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Avatar, Box, Radio, Typography } from '@material-ui/core';
import { keyEmptyCheck } from 'aurora-utils/utils';
// import UserProfile from 'aurora-images/user_profile.svg';
import { ADGMImage } from 'aurora-components';

function Contact(props) {
  const { classes, contact, selected, setSelected, setRemoveModalConfig, checksDisabled, profileMode } = props;
  const lang = localStorage.getItem('lang');
  const onItemClick = useCallback(
    async data => {
      if (selected?.id === data.id) {
        setSelected(null);
        return;
      }
      setSelected(data);
    },
    [contact, selected],
  );

  return (
    <Box className={classes.contactContainer}>
      <Box
        display='flex'
        alignItems='center'
        justifyContent='space-between'
        width='100%'
        py={1}
        onClick={() => onItemClick(contact)}
        className={classNames(checksDisabled && classes.checkDisabled, classes.contactDetails)}
      >
        <Radio
          edge='start'
          checked={selected?.id === contact.id || false}
          disabled={checksDisabled}
          tabIndex={-1}
          disableRipple
          classes={{
            root: classes.itemCheckbox,
            checked: classes.itemCheckboxChecked,
            disabled: classes.checkDisabled,
          }}
        />
        <Box display='flex' alignItems='center' className={classes.avatarContainer}>
          <Avatar
            alt='Avatar alt'
            // src={UserProfile}
            src='/images/avatar_profile.svg'
            className={classes.avatar}
          />
          <Box>
            {/* <Hidden smDown>
              <Typography variant='h6' className={classes.label}>
                {keyEmptyCheck('Owner #1')}
              </Typography>
            </Hidden> */}
            <Typography variant='h6' className={classes.label}>
              {keyEmptyCheck('Name')}
            </Typography>
            <Typography variant='h6' className={classes.contactText}>
              {lang === 'ar' ? contact.nameAr : contact.nameEn}
            </Typography>
          </Box>
        </Box>
        <Box className={classes.details}>
          <Typography className={classes.label}>{keyEmptyCheck('email')}</Typography>
          <Typography variant='h6' className={classes.contactText}>
            {contact.email}
          </Typography>
        </Box>
        <Box className={classes.details}>
          <Typography className={classes.label}>{keyEmptyCheck('mobile')}</Typography>
          <Typography variant='h6' className={classes.contactText}>
            {contact.mobile}
          </Typography>
        </Box>
      </Box>

      {/* Remove Contact */}
      {profileMode && (
        <Box
          onClick={() => setRemoveModalConfig({ data: contact, open: true })}
          display='flex'
          alignItems='center'
          mt={1}
          className={classes.removeContact}
        >
          <ADGMImage name='remove.svg' alt='removeIcon' />
          <Typography>{keyEmptyCheck('remove_contact_details')}</Typography>
        </Box>
      )}
    </Box>
  );
}
Contact.propTypes = {
  classes: PropTypes.object.isRequired,
  contact: PropTypes.object.isRequired,
  selected: PropTypes.object.isRequired,
  setRemoveModalConfig: PropTypes.func.isRequired,
  setSelected: PropTypes.func.isRequired,
  profileMode: PropTypes.bool.isRequired,
  checksDisabled: PropTypes.bool,
};
Contact.defaultProps = {
  checksDisabled: false,
};
export default Contact;
